<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
  >
    <path
      d="M15.6988 2.21167L9.10598 10.4723C8.48058 11.228 7.51641 11.228 6.91706 10.4723L0.324225 2.21167C-0.301182 1.42991 0.0115214 0.830566 0.975691 0.830566H15.0474C16.0376 0.830566 16.3242 1.42991 15.6988 2.21167Z"
      fill="#5E6A79"
    />
  </svg>
</template>

<script>
export default {
  name: "IconDownArrow2",
};
</script>

<style></style>
